/**
 * Renders a new collection based on the given URL, replacing the current content and pagination.
 * If no URL is provided, it will use the current URL.
 * @param {string} [rawUrl] - The URL to render the collection from.
 * @param {Event} [event] - The event to preventDefault on, if provided.
 * @returns {Promise<void>}
 */
const renderCollection = async (rawUrl, event) => {
  if (event) event.preventDefault();

  const wrapper = document.querySelector('[id^="main-collection--"]');
  const fallbackUrl =
    wrapper?.dataset.url || window.location.pathname + window.location.search;
  const base = new URL(fallbackUrl, window.location.origin);
  const sanitized = (rawUrl || "").trim().replace(/^#/, "");
  const targetUrl = new URL(sanitized || base.href, base);

  const sectionUrl = new URL(targetUrl.toString());
  //sectionUrl.searchParams.set("section_id", "main-collection");

  try {
    const response = await fetch(sectionUrl.toString());
    if (!response.ok)
      throw new Error(`Request failed with status ${response.status}`);

    const parser = new DOMParser();
    const parsed = parser.parseFromString(await response.text(), "text/html");

    const currentContent = document.querySelector(".content-area");
    const nextContent = parsed.querySelector(".content-area");
    if (currentContent && nextContent) currentContent.replaceWith(nextContent);

    const currentTopArea = document.querySelector(".toparea-s");
    const nextTopArea = parsed.querySelector(".toparea-s");
    if (currentTopArea && nextTopArea) currentTopArea.replaceWith(nextTopArea);

    const currentPagination = document.querySelector(".pagination-area");
    const nextPagination = parsed.querySelector(".pagination-area");

    if (currentPagination && nextPagination) {
      currentPagination.replaceWith(nextPagination);
      document.querySelectorAll(".pagination-area a[href]").forEach((link) => {
        link.addEventListener("click", (linkEvent) =>
          renderCollection(link.getAttribute("href") || "", linkEvent)
        );
      });
    }

    window.history.pushState(null, "", targetUrl.pathname + targetUrl.search);
    console.log("[FilterItem] Replaced HTML elements");
  } catch (error) {
    console.error("[FilterItem] Failed to render collection", error);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const filterTitles = Array.from(
    document.querySelectorAll(".main-collection__filter-title")
  );
  const filterGroups = Array.from(
    document.querySelectorAll(".main-collection__filter-group")
  );

  if (!filterTitles.length || !filterGroups.length) return;

  const toggleGroups = (targetId) => {
    if (!targetId) return;
    filterTitles.forEach((title) =>
      title.classList.toggle("active", title.dataset.targetBody === targetId)
    );
    filterGroups.forEach((group) => {
      const matches =
        group.dataset.filterBody === targetId || group.id === targetId;
      group.hidden = !matches;
      group.classList.toggle("active", matches);
    });
  };

  // Check if any filter item is active and activate its parent tab
  const activeFilterItem = document.querySelector(".main-collection__filter-item.active");
  let initialTarget;

  if (activeFilterItem) {
    const parentGroup = activeFilterItem.closest(".main-collection__filter-group");
    initialTarget = parentGroup?.id;
  } else {
    initialTarget = (
      filterTitles.find((title) => title.classList.contains("active")) ||
      filterTitles[0]
    )?.dataset.targetBody;
  }

  toggleGroups(initialTarget);

  filterTitles.forEach((title) => {
    title.addEventListener("click", () =>
      toggleGroups(title.dataset.targetBody)
    );
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const filterItems = document.querySelectorAll(
    ".main-collection__filter-item"
  );
  filterItems.forEach((item) => {
    item.addEventListener("click", (event) => {
      filterItems.forEach((filter) =>
        filter.classList.toggle("active", filter === item)
      );
      renderCollection(
        item.getAttribute("href") || item.dataset.url || "",
        event
      );
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".pagination-area a[href]").forEach((link) => {
    link.addEventListener("click", (event) =>
      renderCollection(link.getAttribute("href") || "", event)
    );
  });
});
